import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// BLOCK 184 — safe error-message extraction. NEVER returns a raw object
// (passing one straight to toast.error() crashes React's render tree —
// "Objects are not valid as a React child" — with no error boundary
// around it, that crash took down the whole page as a blank screen).
export function errMsg(e, fallback = "Something went wrong") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (detail && typeof detail === "object" && typeof detail.message === "string") return detail.message;
  return fallback;
}

// Structured error code (e.g. "mfa_step_up_required") when the backend
// returned a {error: "..."} object instead of a plain string detail.
export function errCode(e) {
  const detail = e?.response?.data?.detail;
  return detail && typeof detail === "object" ? detail.error : null;
}
